export default __webpack_public_path__ + "static/photoelectric6-43aafb23ad3b943d1002f8e17f0f4be8.png";